module.exports = __webpack_public_path__ + "img/booking-icon.d1045952.svg";